import React from 'react';
import { Box, Checkbox } from 'edenred-ui';
import { useTheme } from 'styled-components';
import { Trans } from 'react-i18next';

import { IBenefits } from '@epi-models/pages/BenefitGroups';

import { StyledSelectBenefitCard } from '../BenefitTypeCard/BenefitTypeCard.styles';
import { BenefitTypeIcon } from '../BenefitTypeIcon/BenefitTypeIcon';

interface BenefitCheckboxProps {
  benefitType: IBenefits;
  disabled?: boolean;
  handleToggleCheckbox: () => void;
  isChecked: boolean;
}

export const BenefitCheckbox = ({
  benefitType,
  disabled,
  handleToggleCheckbox,
  isChecked
}: BenefitCheckboxProps) => {
  const { gray25, primaryBackColorLight, primaryBackLight } = useTheme();

  return (
    <StyledSelectBenefitCard
      isSelected={isChecked}
      onClick={disabled ? null : handleToggleCheckbox}
      disabled={disabled}
    >
      <Box
        display="flex"
        alignItems="center"
        gap={1}
        color={disabled ? gray25 : primaryBackLight}
      >
        <Box
          width={32}
          height={32}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <BenefitTypeIcon
            benefit={benefitType?.toLowerCase()}
            color={disabled ? gray25 : primaryBackColorLight}
          />
        </Box>
        <Trans i18nKey={`containers.benefit_groups.benefits.${benefitType}`} />
      </Box>
      <Box>
        <Checkbox checked={isChecked} disabled={disabled} />
      </Box>
    </StyledSelectBenefitCard>
  );
};
